var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { resolveSvgIcon } from '../../utils/internalUtils';
import Switch from '../Switch/Switch';
var SwitchCellRenderer = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, icon = _a.icon, iconProps = _a.iconProps, label = _a.label, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, switchProps = _a.switchProps, value = _a.value;
    return (React.createElement("div", { className: "switch-renderer" },
        label && React.createElement("span", null, label),
        React.createElement(Switch, __assign({ checked: value, onChange: onChange, disabled: disabled }, switchProps)),
        resolveSvgIcon(icon, iconProps)));
};
export default SwitchCellRenderer;
